module.exports = __webpack_public_path__ + "img/trip-icon_personas.af856236.svg";